import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class LandingServiceService {
    getAllBanners() {
      return this.http.get(`${this.baseUrl}/getAllBanners`);

    }
    getAllEminents() {
      return this.http.get(`${this.baseUrl}/getAllEminents`);

    }
    getAllAnnouncements() {
      return this.http.get(`${this.baseUrl}/getAllAnnouncements`);

    }
    getAllHomeAnnouncement(){
      return this.http.get(`${this.baseUrl}/getAllHomeAnnouncement`);
    }
  private baseUrl = myGlobals.baseUrl; 
  constructor(private http: HttpClient) { }
  getUserCount() {
    return this.http.get(`${this.baseUrl}/getUserCount`);
  }
  getAllNews() {
    return this.http.get(`${this.baseUrl}/getAllNews`);
  }
  getAllEvents() {
    return this.http.get(`${this.baseUrl}/getAllEvents`);
  }
  getUpcomingEvents(){
    return this.http.get(`${this.baseUrl}/getUpcomingEvents`);
  }
  getAllFaqs(){
    return this.http.get(`${this.baseUrl}/getAllFaqs`);
  }
  getSingleEvents() {
    return this.http.get(`${this.baseUrl}/getSingleEvents`);
  }
  getImageGallery() {
    return this.http.get(`${this.baseUrl}/getImageGallery`);
  }
  getVideoGallery() {
    return this.http.get(`${this.baseUrl}/getVideoGallery`);
  }
  getAllDownloads() {
    return this.http.get(`${this.baseUrl}/getAllDownloads`);
  }
  getAllDirectoryHomePage() {
    return this.http.get(`${this.baseUrl}/getAllDirectoryHomePage`);
  }

  getAllGuidelinesHome(){
    return this.http.get(`${this.baseUrl}/getAllGuidelinesHome`);
  }

  getAllLeadershipHome(){
    return this.http.get(`${this.baseUrl}/getAllLeadershipHome`);
  }

}
